// extracted by mini-css-extract-plugin
export default {"container":"quickStatComponent_container__euLhy"};